// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { 
//   Mail, 
//   Lock, 
//   Eye, 
//   EyeOff, 
//   ArrowRight,
//   Zap,
//   UtensilsCrossed,
//   ChefHat
// } from 'lucide-react';

// import { getData, postData } from '../Services/Fetchnodeservices';

// // ── IMAGE BASE URL ──
// const IMAGE_BASE_URL = process.env.REACT_APP_API_URL || 'https://new.zaptodoor.com/uploads/';
// // const IMAGE_BASE_URL = 'https://new.zaptodoor.com/uploadnew/upload/';

// const LoginPage = ({ onLogin }) => {
//   const navigate = useNavigate();
//   const [contact, setcontact] = useState('');
//   const [password, setPassword] = useState('');
//   const [showPassword, setShowPassword] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const [focusedField, setFocusedField] = useState(null);
  
//   // 👇 Slider State
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [sliderImages, setSliderImages] = useState([
//     "https://plus.unsplash.com/premium_photo-1681841594224-ad729a249113?w=800&auto=format&fit=crop&q=80",
//     "https://images.unsplash.com/photo-1537047902294-62a40c20a6ae?w=800&auto=format&fit=crop&q=80",
//     "https://images.unsplash.com/photo-1590846406792-0adc7f938f1d?w=800&auto=format&fit=crop&q=80"
//   ]);
//   const [loadingImages, setLoadingImages] = useState(true);

//   // ── Get Image URL ──
//   const getImageUrl = (imageName) => {
//     if (!imageName) return null;
//     if (imageName.startsWith('http://') || imageName.startsWith('https://')) {
//       return imageName;
//     }
//     // Remove any existing path if present
//     let filename = imageName;
//     if (filename.includes('/')) {
//       filename = filename.split('/').pop();
//     }
//     return `${IMAGE_BASE_URL}${filename}`;
//   };

//   // ── Fetch Login Banner Images ──
//   useEffect(() => {
//     const fetchLoginBanners = async () => {
//    const response = await getData("RestaurantOfferBanne/restaurant-login-bannerfetch");

// if (response.success && response.data.length > 0) {
//   const banner = response.data.find(item => item.status === 1);

//   if (banner) {
//     const imageUrls = banner.images.map(
//       (img) => `${IMAGE_BASE_URL}${img}`
//     );

//     console.log("IMAGE URLS =>", imageUrls);

//     setSliderImages(imageUrls);
//   }
// }

// setLoadingImages(false);
//     };

//     fetchLoginBanners();
//   }, []);

//   // 👇 Auto-play slider effect
//   useEffect(() => {
//     // Only start timer if we have images
//     if (sliderImages.length > 0) {
//       const timer = setInterval(() => {
//         setCurrentSlide((prev) => (prev + 1) % sliderImages.length);
//       }, 4000); // Change image every 4 seconds
//       return () => clearInterval(timer);
//     }
//   }, [sliderImages.length]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError('');
    
//     if (!contact || !password) {
//       setError('Please fill in all fields');
//       return;
//     }

//     setLoading(true);

//     try {
//       // Using postData from Fetchnodeservices
//       const response = await postData('vandersuperadmin/super-admin/login', {
//         contact: contact.trim(),
//         password: password.trim()
//       });

//       console.log('=== FULL LOGIN RESPONSE ===', response);

//       if (response && response.success === true) {
//         console.log('✅ Login successful!');

//         if (!response.user) {
//           console.error('❌ No user data in response:', response);
//           setError('Invalid response from server');
//           setLoading(false);
//           return;
//         }

//         const userData = response.user;
//         console.log('📦 User Data:', userData);

//         if (!userData.owner_name) {
//           console.warn('⚠️ owner_name not found in user data');
//         }

//         const userDataToStore = {
//           id: userData.id || userData._id || null,
//           contact: userData.contact || contact,
//           name: userData.owner_name || userData.restaurant_name || userData.name || 'Vendor',
//           owner_name: userData.owner_name || '',
//           role: userData.role || 'vendor',
//           restaurantId: userData.id || userData._id || null,
//           restaurant_name: userData.restaurant_name || '',
//           mobile: userData.mobile || '',
//           ...userData
//         };

//         console.log('💾 Data to save in localStorage:', userDataToStore);

//         try {
//           // Store user data in localStorage
//           localStorage.setItem('userToken', 'authenticated');
//           localStorage.setItem('userData', JSON.stringify(userDataToStore));
//           localStorage.setItem('restaurantId', String(userDataToStore.id || userDataToStore.restaurantId || ''));
//           localStorage.setItem('owner_name', userDataToStore.owner_name || '');
//           localStorage.setItem('usercontact', userDataToStore.contact || '');
          
//           const savedToken = localStorage.getItem('userToken');
//           const savedUserData = localStorage.getItem('userData');
//           const savedOwnerName = localStorage.getItem('owner_name');
          
//           console.log('✅ Saved userToken:', savedToken);
//           console.log('✅ Saved userData:', savedUserData);
//           console.log('✅ Saved owner_name:', savedOwnerName);
          
//           if (!savedUserData) {
//             console.error('❌ FAILED: userData not saved to localStorage');
//             setError('Failed to save login data. Please try again.');
//             setLoading(false);
//             return;
//           }
          
//           if (savedToken !== 'authenticated') {
//             console.error('❌ FAILED: userToken not saved correctly');
//             setError('Failed to save login token. Please try again.');
//             setLoading(false);
//             return;
//           }

//           console.log('✅ All data saved successfully to localStorage!');
          
//           if (onLogin) {
//             console.log('🔄 Calling onLogin with user data');
//             onLogin(userDataToStore);
//           }

//           setError(''); 
//           console.log('🎉 Login complete! Redirecting to dashboard...');

//           navigate('/dashboard');

//         } catch (storageError) {
//           console.error('❌ localStorage error:', storageError);
//           setError('Error saving login data. Please try again.');
//           setLoading(false);
//           return;
//         }

//       } else {
//         console.log('❌ Login failed - success is false or missing');
//         console.log('Response:', response);
//         const errorMsg = response?.message || response?.error || 'Invalid contact or password.';
//         setError(errorMsg);
//         setLoading(false);
//       }
//     } catch (err) {
//       console.error('❌ Network/Server error:', err);
//       setError('Network error. Please check your connection and try again.');
//       setLoading(false);
//     }
//   };

//   const styles = {
//     container: {
//       minHeight: '100vh',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 50%, #fcd34d 100%)',
//       fontFamily: "'Inter', 'DM Sans', -apple-system, sans-serif",
//       padding: '20px',
//     },
//     loginCard: {
//       width: '100%',
//       maxWidth: '850px',
//       background: '#ffffff',
//       borderRadius: '24px',
//       overflow: 'hidden',
//       boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.15)',
//       animation: 'slideUp 0.6s cubic-bezier(0.16, 1, 0.3, 1)',
//       display: 'flex',
//       flexDirection: 'row',
//     },
//     formSection: {
//       width: '50%',
//       padding: '32px 40px',
//       display: 'flex',
//       flexDirection: 'column',
//       justifyContent: 'center',
//     },
//     imageSection: {
//       position: 'relative',
//       width: '50%',
//       minHeight: '500px',
//       overflow: 'hidden',
//       display: 'flex',
//       flexDirection: 'column',
//       justifyContent: 'flex-end',
//     },
//     sliderContainer: {
//       position: 'absolute',
//       top: 0,
//       left: 0,
//       width: '100%',
//       height: '100%',
//     },
//     slide: (img, isActive) => ({
//       position: 'absolute',
//       top: 0,
//       left: 0,
//       width: '100%',
//       height: '100%',
//       backgroundImage: `url(${img})`,
//       backgroundSize: 'cover',
//       backgroundPosition: 'center',
//       transition: 'opacity 1s ease-in-out, transform 6s ease-out',
//       opacity: isActive ? 1 : 0,
//       transform: isActive ? 'scale(1.05)' : 'scale(1)',
//     }),
//     imageOverlay: {
//       position: 'absolute',
//       top: 0,
//       left: 0,
//       right: 0,
//       bottom: 0,
//       background: 'linear-gradient(to bottom, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.85) 100%)',
//       zIndex: 2,
//     },
//     sliderDots: {
//       position: 'absolute',
//       bottom: '120px',
//       left: '50%',
//       transform: 'translateX(-50%)',
//       display: 'flex',
//       gap: '8px',
//       zIndex: 4,
//     },
//     dot: (isActive) => ({
//       width: isActive ? '24px' : '8px',
//       height: '8px',
//       borderRadius: '4px',
//       background: isActive ? '#f97316' : 'rgba(255,255,255,0.4)',
//       transition: 'all 0.3s ease',
//       cursor: 'pointer',
//     }),
//     imageContent: {
//       position: 'relative',
//       zIndex: 3,
//       color: '#ffffff',
//       padding: '32px',
//     },
//     logoBadge: {
//       display: 'inline-flex',
//       alignItems: 'center',
//       gap: '6px',
//       padding: '6px 12px',
//       background: 'rgba(255, 255, 255, 0.15)',
//       backdropFilter: 'blur(10px)',
//       borderRadius: '9999px',
//       marginBottom: '12px',
//       border: '1px solid rgba(255, 255, 255, 0.2)',
//     },
//     imageTitle: {
//       fontSize: '24px',
//       fontWeight: 800,
//       marginBottom: '6px',
//       letterSpacing: '-0.5px',
//     },
//     imageSubtitle: {
//       fontSize: '14px',
//       opacity: 0.9,
//       fontWeight: 500,
//       marginBottom: '16px',
//     },
//     welcomeText: {
//       fontSize: '13px',
//       fontWeight: 700,
//       color: '#f97316',
//       marginBottom: '6px',
//       letterSpacing: '1px',
//       textTransform: 'uppercase',
//     },
//     formTitle: {
//       fontSize: '22px',
//       fontWeight: 800,
//       color: '#111827',
//       marginBottom: '6px',
//     },
//     formSubtitle: {
//       fontSize: '14px',
//       color: '#6b7280',
//       marginBottom: '24px',
//     },
//     inputGroup: {
//       marginBottom: '16px',
//     },
//     label: {
//       display: 'block',
//       fontSize: '13px',
//       fontWeight: 600,
//       color: '#374151',
//       marginBottom: '6px',
//     },
//     inputWrapper: {
//       position: 'relative',
//     },
//     inputIcon: {
//       position: 'absolute',
//       left: '14px',
//       top: '50%',
//       transform: 'translateY(-50%)',
//       color: '#9ca3af',
//       transition: 'color 0.2s ease',
//     },
//     input: {
//       width: '100%',
//       padding: '12px 14px 12px 42px',
//       border: '2px solid #e5e7eb',
//       borderRadius: '10px',
//       fontSize: '14px',
//       color: '#111827',
//       backgroundColor: '#ffffff',
//       transition: 'all 0.3s ease',
//       outline: 'none',
//       fontFamily: 'inherit',
//       boxSizing: 'border-box',
//     },
//     inputFocus: {
//       borderColor: '#f97316',
//       boxShadow: '0 0 0 4px rgba(249, 115, 22, 0.1)',
//     },
//     passwordToggle: {
//       position: 'absolute',
//       right: '14px',
//       top: '50%',
//       transform: 'translateY(-50%)',
//       background: 'none',
//       border: 'none',
//       color: '#9ca3af',
//       cursor: 'pointer',
//       padding: '4px',
//       display: 'flex',
//       alignItems: 'center',
//       transition: 'color 0.2s ease',
//     },
//     loginButton: {
//       width: '100%',
//       padding: '14px',
//       background: 'linear-gradient(135deg, #f97316 0%, #ef4444 100%)',
//       border: 'none',
//       borderRadius: '10px',
//       color: '#ffffff',
//       fontSize: '15px',
//       fontWeight: 700,
//       cursor: 'pointer',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       gap: '8px',
//       boxShadow: '0 8px 20px -4px rgba(249, 115, 22, 0.4)',
//       transition: 'all 0.3s ease',
//       marginTop: '8px',
//     },
//     supportText: {
//       textAlign: 'center',
//       marginTop: '16px',
//       fontSize: '13px',
//       color: '#6b7280',
//     },
//     supportLink: {
//       color: '#f97316',
//       fontWeight: 700,
//       background: 'none',
//       border: 'none',
//       cursor: 'pointer',
//       fontSize: '13px',
//       textDecoration: 'underline',
//       textUnderlineOffset: '2px',
//     },
//     loadingSpinner: {
//       width: '18px',
//       height: '18px',
//       border: '2.5px solid rgba(255,255,255,0.3)',
//       borderTop: '2.5px solid #ffffff',
//       borderRadius: '50%',
//       animation: 'spin 0.8s linear infinite',
//     },
//     errorBox: {
//       display: 'flex',
//       alignItems: 'center',
//       gap: '8px',
//       padding: '10px 14px',
//       borderRadius: '8px',
//       background: '#fef2f2',
//       border: '1px solid #fecaca',
//       color: '#dc2626',
//       fontSize: '13px',
//       fontWeight: 500,
//       marginBottom: '16px',
//     },
//     foodIcons: {
//       display: 'flex',
//       gap: '10px',
//     },
//     foodIcon: {
//       width: '40px',
//       height: '40px',
//       background: 'rgba(255, 255, 255, 0.15)',
//       backdropFilter: 'blur(10px)',
//       borderRadius: '10px',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       border: '1px solid rgba(255, 255, 255, 0.2)',
//     },
//     loadingContainer: {
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       width: '100%',
//       height: '100%',
//       position: 'absolute',
//       top: 0,
//       left: 0,
//       zIndex: 5,
//       background: 'rgba(0,0,0,0.3)',
//       backdropFilter: 'blur(2px)',
//     },
//     loadingSpinnerLarge: {
//       width: '40px',
//       height: '40px',
//       border: '3px solid rgba(255,255,255,0.3)',
//       borderTop: '3px solid #ffffff',
//       borderRadius: '50%',
//       animation: 'spin 0.8s linear infinite',
//     },
//   };

//   return (
//     <div style={styles.container}>
//       <style>{`
//         @keyframes slideUp {
//           from { opacity: 0; transform: translateY(30px) scale(0.95); }
//           to { opacity: 1; transform: translateY(0) scale(1); }
//         }
//         @keyframes spin {
//           from { transform: rotate(0deg); }
//           to { transform: rotate(360deg); }
//         }
//         @media (max-width: 768px) {
//           .login-card {
//             flex-direction: column !important;
//             max-width: 100% !important;
//           }
//           .image-section {
//             width: 100% !important;
//             height: 220px !important;
//             min-height: 220px !important;
//             order: 1;
//           }
//           .slider-dots {
//             bottom: 20px !important;
//           }
//           .image-content {
//             padding: 20px !important;
//           }
//           .form-section {
//             width: 100% !important;
//             padding: 24px 20px !important;
//             order: 2;
//           }
//         }
//       `}</style>

//       <div style={styles.loginCard} className="login-card">
        
//         {/* 👈 FORM SECTION (LEFT SIDE) */}
//         <div style={styles.formSection} className="form-section">
//           <div style={styles.welcomeText}>Vendor Portal</div>
//           <h2 style={styles.formTitle}>Welcome back!</h2>
//           <p style={styles.formSubtitle}>Sign in to access your dashboard</p>

//           <form onSubmit={handleSubmit}>
//             {error && (
//               <div style={styles.errorBox}>
//                 <span>⚠️</span>
//                 <span>{error}</span>
//               </div>
//             )}

//             <div style={styles.inputGroup}>
//               <label style={styles.label}>contact Address</label>
//               <div style={styles.inputWrapper}>
//                 <Mail size={18} style={{
//                   ...styles.inputIcon,
//                   color: focusedField === 'contact' ? '#f97316' : '#9ca3af'
//                 }} />
//                 <input
//                   type="contact"
//                   placeholder="vendor@restaurant.com"
//                   value={contact}
//                   onChange={(e) => setcontact(e.target.value)}
//                   onFocus={() => setFocusedField('contact')}
//                   onBlur={() => setFocusedField(null)}
//                   style={{
//                     ...styles.input,
//                     ...(focusedField === 'contact' ? styles.inputFocus : {})
//                   }}
//                   disabled={loading}
//                   autoComplete="contact"
//                 />
//               </div>
//             </div>

//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Password</label>
//               <div style={styles.inputWrapper}>
//                 <Lock size={18} style={{
//                   ...styles.inputIcon,
//                   color: focusedField === 'password' ? '#f97316' : '#9ca3af'
//                 }} />
//                 <input
//                   type={showPassword ? 'text' : 'password'}
//                   placeholder="Enter your password"
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                   onFocus={() => setFocusedField('password')}
//                   onBlur={() => setFocusedField(null)}
//                   style={{
//                     ...styles.input,
//                     ...(focusedField === 'password' ? styles.inputFocus : {})
//                   }}
//                   disabled={loading}
//                   autoComplete="current-password"
//                 />
//                 <button
//                   type="button"
//                   style={styles.passwordToggle}
//                   onClick={() => setShowPassword(!showPassword)}
//                   disabled={loading}
//                   onMouseEnter={(e) => e.currentTarget.style.color = '#f97316'}
//                   onMouseLeave={(e) => e.currentTarget.style.color = '#9ca3af'}
//                 >
//                   {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
//                 </button>
//               </div>
//             </div>

//             <button
//               type="submit"
//               style={{
//                 ...styles.loginButton,
//                 ...(loading ? { opacity: 0.7, cursor: 'not-allowed', transform: 'none' } : {})
//               }}
//               disabled={loading}
//               onMouseEnter={(e) => {
//                 if (!loading) {
//                   e.currentTarget.style.transform = 'translateY(-2px)';
//                   e.currentTarget.style.boxShadow = '0 12px 24px -4px rgba(249, 115, 22, 0.5)';
//                 }
//               }}
//               onMouseLeave={(e) => {
//                 e.currentTarget.style.transform = 'translateY(0)';
//                 e.currentTarget.style.boxShadow = '0 8px 20px -4px rgba(249, 115, 22, 0.4)';
//               }}
//             >
//               {loading ? (
//                 <div style={styles.loadingSpinner} />
//               ) : (
//                 <>
//                   Sign In
//                   <ArrowRight size={18} />
//                 </>
//               )}
//             </button>

//             <div style={styles.supportText}>
//               New vendor?{' '}
//               <button
//                 type="button"
//                 style={styles.supportLink}
//                 onClick={() => alert('Contact support@zaptodoor.com for onboarding')}
//               >
//                 Get in touch
//               </button>
//             </div>
//           </form>
//         </div>

//         {/* 👉 IMAGE SLIDER SECTION (RIGHT SIDE) */}
//         <div style={styles.imageSection} className="image-section">
          
//           {/* Loading overlay */}
//           {loadingImages && (
//             <div style={styles.loadingContainer}>
//               <div style={styles.loadingSpinnerLarge} />
//             </div>
//           )}

//           {/* Slider Images */}
//           <div style={styles.sliderContainer}>
//             {sliderImages.map((img, index) => (
//               <div 
//                 key={index} 
//                 style={styles.slide(img, index === currentSlide)} 
//               />
//             ))}
//           </div>

//           {/* Dark Overlay for text readability */}
//           <div style={styles.imageOverlay} />

//           {/* Navigation Dots */}
//           <div style={styles.sliderDots} className="slider-dots">
//             {sliderImages.map((_, index) => (
//               <div 
//                 key={index} 
//                 style={styles.dot(index === currentSlide)}
//                 onClick={() => setCurrentSlide(index)}
//               />
//             ))}
//           </div>
          
//           {/* Text Content */}
//           <div style={styles.imageContent} className="image-content">
//             <div style={styles.logoBadge}>
//               <Zap size={14} color="#ffffff" fill="#ffffff" />
//               <span style={{fontSize: '12px', fontWeight: 600}}>ZapToDoor</span>
//             </div>
//             <h1 style={styles.imageTitle}>Partner with Us</h1>
//             <p style={styles.imageSubtitle}>Manage your restaurant orders & grow your business</p>
            
//             <div style={styles.foodIcons}>
//               <div style={styles.foodIcon}>
//                 <UtensilsCrossed size={20} color="#ffffff" />
//               </div>
//               <div style={styles.foodIcon}>
//                 <ChefHat size={20} color="#ffffff" />
//               </div>
//               <div style={styles.foodIcon}>
//                 <Zap size={20} color="#fbbf24" fill="#fbbf24" />
//               </div>
//             </div>
//           </div>
//         </div>

//       </div>
//     </div>
//   );
// };

// export default LoginPage;

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Mail, 
  Lock, 
  Eye, 
  EyeOff, 
  ArrowRight,
  Zap,
  UtensilsCrossed,
  ChefHat
} from 'lucide-react';

import { getData, postData, serverURL } from '../Services/Fetchnodeservices';

// ── IMAGE BASE URL ──
const IMAGE_BASE_URL = `${serverURL}/uploads/`;

const LoginPage = ({ onLogin }) => {
  const navigate = useNavigate();
  const [contact, setContact] = useState('');  // ✅ contact field
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [focusedField, setFocusedField] = useState(null);
  
  // Slider State
  const [currentSlide, setCurrentSlide] = useState(0);
  // Empty means the admin has not activated a login banner. Never keep a
  // fallback poster here, otherwise an inactive banner would still be shown.
  const [sliderImages, setSliderImages] = useState([]);
  const [loadingImages, setLoadingImages] = useState(true);

  // ── Get Image URL ──
  const getImageUrl = (imageName) => {
    if (!imageName) return null;
    if (imageName.startsWith('http://') || imageName.startsWith('https://')) {
      return imageName;
    }
    let filename = imageName;
    if (filename.includes('/')) {
      filename = filename.split('/').pop();
    }
    return `${IMAGE_BASE_URL}${filename}`;
  };

  // ── Fetch Login Banner Images ──
  useEffect(() => {
    const fetchLoginBanners = async () => {
      try {
        const response = await getData("RestaurantOfferBanne/restaurant-login-bannerfetch");
        if (response.success && Array.isArray(response.data)) {
          // MySQL may return status as either 1 or "1".
          const banner = response.data.find(item => Number(item.status) === 1);
          if (banner) {
            const imageUrls = (banner.images || [])
              .map(getImageUrl)
              .filter(Boolean);
            setSliderImages(imageUrls);
            setCurrentSlide(0);
          } else {
            setSliderImages([]);
            setCurrentSlide(0);
          }
        }
      } catch (e) {
        console.error('Banner fetch error:', e);
      } finally {
        setLoadingImages(false);
      }
    };
    fetchLoginBanners();
    const refreshTimer = setInterval(fetchLoginBanners, 30000);
    return () => clearInterval(refreshTimer);
  }, []);

  // Auto-play slider
  useEffect(() => {
    if (sliderImages.length > 0) {
      const timer = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % sliderImages.length);
      }, 4000);
      return () => clearInterval(timer);
    }
  }, [sliderImages.length]);

  // ============================================================
  // ✅ LOGIN HANDLER - CONTACT SE
  // ============================================================
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    if (!contact || !password) {
      setError('Please fill in all fields');
      return;
    }

    setLoading(true);

    try {
      // ✅ Backend route: /vandersuperadmin/super-admin/login
      const response = await postData('vandersuperadmin/super-admin/login', {
        contact: contact.trim(),   // ✅ contact field
        password: password.trim()
      });

      console.log('=== FULL LOGIN RESPONSE ===', response);

      if (response && response.success === true) {
        console.log('✅ Login successful!');

        if (!response.user) {
          console.error('❌ No user data in response:', response);
          setError('Invalid response from server');
          setLoading(false);
          return;
        }

        const userData = response.user;
        console.log('📦 User Data:', userData);

        // ✅ Store user data in localStorage
        const userDataToStore = {
          id: userData.id || userData._id || null,
          contact: userData.contact || contact,
          name: userData.owner_name || userData.organisation_name || userData.name || 'Vendor',
          owner_name: userData.owner_name || '',
          organisation_name: userData.organisation_name || '',
          role: userData.role || 'vendor',
          restaurantId: userData.id || userData._id || null,
          restaurant_name: userData.organisation_name || userData.restaurant_name || '',
          mobile: userData.contact || '',
          email: userData.email || '',
          is_verify_personalinfo: userData.is_verify_personalinfo || 0,
          is_verify_docinfo: userData.is_verify_docinfo || 0,
          is_verify_bankinfo: userData.is_verify_bankinfo || 0,
          is_approved: userData.is_approved || 0,
          status: userData.status || 0,
          ...userData
        };

        console.log('💾 Data to save in localStorage:', userDataToStore);

        try {
          localStorage.setItem('userToken', 'authenticated');
          localStorage.setItem('userData', JSON.stringify(userDataToStore));
          localStorage.setItem('restaurantId', String(userDataToStore.id || userDataToStore.restaurantId || ''));
          localStorage.setItem('owner_name', userDataToStore.owner_name || userDataToStore.organisation_name || '');
          localStorage.setItem('usercontact', userDataToStore.contact || '');
          
          console.log('✅ All data saved successfully to localStorage!');
          
          if (onLogin) {
            onLogin(userDataToStore);
          }

          setError(''); 
          console.log('🎉 Login complete! Redirecting to dashboard...');
          navigate('/dashboard');

        } catch (storageError) {
          console.error('❌ localStorage error:', storageError);
          setError('Error saving login data. Please try again.');
          setLoading(false);
        }

      } else {
        console.log('❌ Login failed');
        const errorMsg = response?.message || response?.error || 'Invalid contact or password.';
        setError(errorMsg);
        setLoading(false);
      }
    } catch (err) {
      console.error('❌ Network/Server error:', err);
      setError('Network error. Please check your connection and try again.');
      setLoading(false);
    }
  };

  // ============================================================
  // STYLES
  // ============================================================
  const styles = {
    container: {
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 50%, #fcd34d 100%)',
      fontFamily: "'Inter', 'DM Sans', -apple-system, sans-serif",
      padding: '20px',
    },
    loginCard: {
      width: '100%',
      maxWidth: '850px',
      background: '#ffffff',
      borderRadius: '24px',
      overflow: 'hidden',
      boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.15)',
      animation: 'slideUp 0.6s cubic-bezier(0.16, 1, 0.3, 1)',
      display: 'flex',
      flexDirection: 'row',
    },
    formSection: {
      width: '50%',
      padding: '32px 40px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    imageSection: {
      position: 'relative',
      width: '50%',
      minHeight: '500px',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
    },
    sliderContainer: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
    },
    slide: (img, isActive) => ({
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundImage: `url(${img})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      transition: 'opacity 1s ease-in-out, transform 6s ease-out',
      opacity: isActive ? 1 : 0,
      transform: isActive ? 'scale(1.05)' : 'scale(1)',
    }),
    imageOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'linear-gradient(to bottom, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.85) 100%)',
      zIndex: 2,
    },
    sliderDots: {
      position: 'absolute',
      bottom: '120px',
      left: '50%',
      transform: 'translateX(-50%)',
      display: 'flex',
      gap: '8px',
      zIndex: 4,
    },
    dot: (isActive) => ({
      width: isActive ? '24px' : '8px',
      height: '8px',
      borderRadius: '4px',
      background: isActive ? '#f97316' : 'rgba(255,255,255,0.4)',
      transition: 'all 0.3s ease',
      cursor: 'pointer',
    }),
    imageContent: {
      position: 'relative',
      zIndex: 3,
      color: '#ffffff',
      padding: '32px',
    },
    logoBadge: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '6px',
      padding: '6px 12px',
      background: 'rgba(255, 255, 255, 0.15)',
      backdropFilter: 'blur(10px)',
      borderRadius: '9999px',
      marginBottom: '12px',
      border: '1px solid rgba(255, 255, 255, 0.2)',
    },
    imageTitle: {
      fontSize: '24px',
      fontWeight: 800,
      marginBottom: '6px',
      letterSpacing: '-0.5px',
    },
    imageSubtitle: {
      fontSize: '14px',
      opacity: 0.9,
      fontWeight: 500,
      marginBottom: '16px',
    },
    welcomeText: {
      fontSize: '13px',
      fontWeight: 700,
      color: '#f97316',
      marginBottom: '6px',
      letterSpacing: '1px',
      textTransform: 'uppercase',
    },
    formTitle: {
      fontSize: '22px',
      fontWeight: 800,
      color: '#111827',
      marginBottom: '6px',
    },
    formSubtitle: {
      fontSize: '14px',
      color: '#6b7280',
      marginBottom: '24px',
    },
    inputGroup: {
      marginBottom: '16px',
    },
    label: {
      display: 'block',
      fontSize: '13px',
      fontWeight: 600,
      color: '#374151',
      marginBottom: '6px',
    },
    inputWrapper: {
      position: 'relative',
    },
    inputIcon: {
      position: 'absolute',
      left: '14px',
      top: '50%',
      transform: 'translateY(-50%)',
      color: '#9ca3af',
      transition: 'color 0.2s ease',
    },
    input: {
      width: '100%',
      padding: '12px 14px 12px 42px',
      border: '2px solid #e5e7eb',
      borderRadius: '10px',
      fontSize: '14px',
      color: '#111827',
      backgroundColor: '#ffffff',
      transition: 'all 0.3s ease',
      outline: 'none',
      fontFamily: 'inherit',
      boxSizing: 'border-box',
    },
    inputFocus: {
      borderColor: '#f97316',
      boxShadow: '0 0 0 4px rgba(249, 115, 22, 0.1)',
    },
    passwordToggle: {
      position: 'absolute',
      right: '14px',
      top: '50%',
      transform: 'translateY(-50%)',
      background: 'none',
      border: 'none',
      color: '#9ca3af',
      cursor: 'pointer',
      padding: '4px',
      display: 'flex',
      alignItems: 'center',
      transition: 'color 0.2s ease',
    },
    loginButton: {
      width: '100%',
      padding: '14px',
      background: 'linear-gradient(135deg, #f97316 0%, #ef4444 100%)',
      border: 'none',
      borderRadius: '10px',
      color: '#ffffff',
      fontSize: '15px',
      fontWeight: 700,
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
      boxShadow: '0 8px 20px -4px rgba(249, 115, 22, 0.4)',
      transition: 'all 0.3s ease',
      marginTop: '8px',
    },
    supportText: {
      textAlign: 'center',
      marginTop: '16px',
      fontSize: '13px',
      color: '#6b7280',
    },
    supportLink: {
      color: '#f97316',
      fontWeight: 700,
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      fontSize: '13px',
      textDecoration: 'underline',
      textUnderlineOffset: '2px',
    },
    loadingSpinner: {
      width: '18px',
      height: '18px',
      border: '2.5px solid rgba(255,255,255,0.3)',
      borderTop: '2.5px solid #ffffff',
      borderRadius: '50%',
      animation: 'spin 0.8s linear infinite',
    },
    errorBox: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '10px 14px',
      borderRadius: '8px',
      background: '#fef2f2',
      border: '1px solid #fecaca',
      color: '#dc2626',
      fontSize: '13px',
      fontWeight: 500,
      marginBottom: '16px',
    },
    foodIcons: {
      display: 'flex',
      gap: '10px',
    },
    foodIcon: {
      width: '40px',
      height: '40px',
      background: 'rgba(255, 255, 255, 0.15)',
      backdropFilter: 'blur(10px)',
      borderRadius: '10px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: '1px solid rgba(255, 255, 255, 0.2)',
    },
    loadingContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: 5,
      background: 'rgba(0,0,0,0.3)',
      backdropFilter: 'blur(2px)',
    },
    loadingSpinnerLarge: {
      width: '40px',
      height: '40px',
      border: '3px solid rgba(255,255,255,0.3)',
      borderTop: '3px solid #ffffff',
      borderRadius: '50%',
      animation: 'spin 0.8s linear infinite',
    },
  };

  return (
    <div style={styles.container}>
      <style>{`
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(30px) scale(0.95); }
          to { opacity: 1; transform: translateY(0) scale(1); }
        }
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        @media (max-width: 768px) {
          .login-card {
            flex-direction: column !important;
            max-width: 100% !important;
          }
          .image-section {
            width: 100% !important;
            height: 220px !important;
            min-height: 220px !important;
            order: 1;
          }
          .slider-dots {
            bottom: 20px !important;
          }
          .image-content {
            padding: 20px !important;
          }
          .form-section {
            width: 100% !important;
            padding: 24px 20px !important;
            order: 2;
          }
        }
      `}</style>

      <div style={styles.loginCard} className="login-card">
        
        {/* FORM SECTION */}
        <div style={styles.formSection} className="form-section">
          <div style={styles.welcomeText}>Vendor Portal</div>
          <h2 style={styles.formTitle}>Welcome back!</h2>
          <p style={styles.formSubtitle}>Sign in to access your dashboard</p>

          <form onSubmit={handleSubmit}>
            {error && (
              <div style={styles.errorBox}>
                <span>⚠️</span>
                <span>{error}</span>
              </div>
            )}

            {/* ✅ Contact Input - Phone Number */}
            <div style={styles.inputGroup}>
              <label style={styles.label}>Phone Number</label>
              <div style={styles.inputWrapper}>
                <Mail size={18} style={{
                  ...styles.inputIcon,
                  color: focusedField === 'contact' ? '#f97316' : '#9ca3af'
                }} />
                <input
                  type="text"
                  placeholder="Enter registered phone number"
                  value={contact}
                  onChange={(e) => setContact(e.target.value)}
                  onFocus={() => setFocusedField('contact')}
                  onBlur={() => setFocusedField(null)}
                  style={{
                    ...styles.input,
                    ...(focusedField === 'contact' ? styles.inputFocus : {})
                  }}
                  disabled={loading}
                  autoComplete="tel"
                />
              </div>
            </div>

            {/* Password Input */}
            <div style={styles.inputGroup}>
              <label style={styles.label}>Password</label>
              <div style={styles.inputWrapper}>
                <Lock size={18} style={{
                  ...styles.inputIcon,
                  color: focusedField === 'password' ? '#f97316' : '#9ca3af'
                }} />
                <input
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  onFocus={() => setFocusedField('password')}
                  onBlur={() => setFocusedField(null)}
                  style={{
                    ...styles.input,
                    ...(focusedField === 'password' ? styles.inputFocus : {})
                  }}
                  disabled={loading}
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  style={styles.passwordToggle}
                  onClick={() => setShowPassword(!showPassword)}
                  disabled={loading}
                  onMouseEnter={(e) => e.currentTarget.style.color = '#f97316'}
                  onMouseLeave={(e) => e.currentTarget.style.color = '#9ca3af'}
                >
                  {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>

            <button
              type="submit"
              style={{
                ...styles.loginButton,
                ...(loading ? { opacity: 0.7, cursor: 'not-allowed', transform: 'none' } : {})
              }}
              disabled={loading}
              onMouseEnter={(e) => {
                if (!loading) {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 12px 24px -4px rgba(249, 115, 22, 0.5)';
                }
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 8px 20px -4px rgba(249, 115, 22, 0.4)';
              }}
            >
              {loading ? (
                <div style={styles.loadingSpinner} />
              ) : (
                <>
                  Sign In
                  <ArrowRight size={18} />
                </>
              )}
            </button>

            <div style={styles.supportText}>
              New vendor?{' '}
              <button
                type="button"
                style={styles.supportLink}
                onClick={() => alert('Contact support@zaptodoor.com for onboarding')}
              >
                Get in touch
              </button>
            </div>
          </form>
        </div>

        {/* IMAGE SLIDER SECTION */}
        <div style={styles.imageSection} className="image-section">
          
          {loadingImages && (
            <div style={styles.loadingContainer}>
              <div style={styles.loadingSpinnerLarge} />
            </div>
          )}

          <div style={styles.sliderContainer}>
            {sliderImages.map((img, index) => (
              <div 
                key={index} 
                style={styles.slide(img, index === currentSlide)} 
              />
            ))}
          </div>

          <div style={styles.imageOverlay} />

          <div style={styles.sliderDots} className="slider-dots">
            {sliderImages.map((_, index) => (
              <div 
                key={index} 
                style={styles.dot(index === currentSlide)}
                onClick={() => setCurrentSlide(index)}
              />
            ))}
          </div>
          
          <div style={styles.imageContent} className="image-content">
            <div style={styles.logoBadge}>
              <Zap size={14} color="#ffffff" fill="#ffffff" />
              <span style={{fontSize: '12px', fontWeight: 600}}>ZapToDoor</span>
            </div>
            <h1 style={styles.imageTitle}>Partner with Us</h1>
            <p style={styles.imageSubtitle}>Manage your restaurant orders & grow your business</p>
            
            <div style={styles.foodIcons}>
              <div style={styles.foodIcon}>
                <UtensilsCrossed size={20} color="#ffffff" />
              </div>
              <div style={styles.foodIcon}>
                <ChefHat size={20} color="#ffffff" />
              </div>
              <div style={styles.foodIcon}>
                <Zap size={20} color="#fbbf24" fill="#fbbf24" />
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default LoginPage;
